export const GET_OBJECT_PROFILE = "GET_OBJECT_PROFILE";
export const RESET_OBJECT_PROFILE = "RESET_OBJECT_PROFILE";